// extracted by mini-css-extract-plugin
export default {"stop_watch_container":"stop-watch_stop_watch_container__LkX-p"};